module.exports = __webpack_public_path__ + "img/bg.572e3e9b.png";